<ul class="menu-list">
  <li *ngFor="let section of menuList; let i = index" (click)="toggleMenu(i)" [class.show]="activeSectionIndex === i">
    <molecule-menu-section
      [sectionIcon]="section.icon"
      [sectionIconColor]="'#fff'"
      [sectionTitle]="section.title"
      [sectionRoute]="section.route"
    >
    </molecule-menu-section>

    <div class="menu-list__categories" *ngIf="isVisible(section.categories)">
      <ng-container *ngFor="let category of section.categories">
        <molecule-menu-items [menuItemTitle]="category.title" [menuItems]="category" [sectionTitle]="section.title"></molecule-menu-items>
      </ng-container>
    </div>
  </li>
</ul>
